import type * as React from 'react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button/button';

export function AlertDialogAction({ className, ...props }: React.ComponentProps<typeof Button>) {
  return <Button data-slot="alert-dialog-action" className={cn(className)} {...props} />;
}
